import axios from "@/libs/api.request";

// 修改用户密码
export const updatePassword = (data) => {
  return axios.request({
    url: "/backend/commodity/sysUser/updatePassword",
    method: "post",
    data: data
  });
}
// 下载中心-查询列表
export const queryDownloadProgressList = (data) => {
  return axios.request({
    url: "/backend/download-center/downloadProgress/queryDownloadProgressList",
    method: "post",
    data: data
  });
}
// 下载中心-删除下载
export const deleteDownloadProgress = (data) => {
  return axios.request({
    url: "/backend/download-center/downloadProgress/deleteDownloadProgress",
    method: "post",
    data: data
  });
}
